import { HTTPError } from 'ky';
import { ENDPOINT } from '~/constants';

import { type UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';
import ToastService from '~/services/toast.service';

import { i18n, log } from '~/utils';

import { type ReprocessingCommentResponse } from './types';

/**
 * Add a comment to the reprocessing invoice with the given process ID.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoice/operation/set_process_comment_invoice_process__process_id__comment_put
 */
export const addInvoiceReprocessingComment = async (
  processId: UUID,
  comment: string,
) => {
  try {
    const response = await vestigasApi
      .put(ENDPOINT.INVOICE_REPROCESSING.ADD_COMMENT(processId), {
        json: { comment },
      })
      .json<ReprocessingCommentResponse>();

    return response;
  } catch (error) {
    log.error({
      message: 'Error saving invoice reprocessing comment',
      error,
    });

    let errorMessage = '';

    if (error instanceof HTTPError) {
      switch (error.response.status) {
        case 422: {
          errorMessage = i18n.t(
            ($) => $.addInvoiceReprocessingComment.error422,
            { ns: 'data' },
          );
          break;
        }

        default: {
          errorMessage = i18n.t(
            ($) => $.addInvoiceReprocessingComment.error.generic,
            { ns: 'data' },
          );
        }
      }
    }

    if (errorMessage) {
      ToastService.error(errorMessage);
    }

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
};
